<template>
  <div class="news">
    <div class="container p-0 pb-5">
      <div class="row">
        <div class="col-12 d-flex justify-content-between align-items-center">
          <!-- <h2 class="headTitle ms-3">{{ tabMenu.title }}</h2> -->

           <h2 class="headTitle ms-3">{{this.$t('videogalerry.title')}}</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="tab-content" id="myTabContent">
            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
              <div class="container">
                <div class="row mt-3">
                  <div class="col-lg-12 p-0">
                    <gallery-template :videos="paginatedVideoData"></gallery-template>
                  </div>
                </div>
                <!-- Pagination Controls -->
                <div v-if="totalPages > 1" class="row mt-4">
                  <div class="col-12 d-flex justify-content-center">
                    <nav aria-label="Page navigation">
                      <ul class="pagination">
                        <li class="page-item" :class="{ disabled: currentPage === 1 }">
                          <button class="page-link" @click="prevPage"><font-awesome-icon
                              icon="fa-solid fa-angle-left" /></button>
                        </li>
                        <li class="page-item" v-for="page in visiblePages" :key="page"
                            :class="{ active: currentPage === page }">
                          <button class="page-link" @click="goToPage(page)">{{ page }}</button>
                        </li>
                        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                          <button class="page-link" @click="nextPage"><font-awesome-icon
                              icon="fa-solid fa-angle-right" /></button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { usePostsStore } from '@/store/PostStore/postStore';
import GalleryTemplate from '@/components/share/GalleryTemplate.vue';

export default {
  data() {
    return {
      postStore: usePostsStore(),
      webPage: '',
      language: 'AL',
      count: 0,
      categoryId: 1141,
      currentPage: 1,
      itemsPerPage: 10,
    };
  },
  components: {
    GalleryTemplate,
  },
  computed: {
    formatedVideoData() {
      return this.postStore.videoPosts.map((post) => ({
        id: post.id,
        data_postimit: post.createdDate,
        title: post.priceDetailsTitle,
        prokuroria: post.webPage,
        youtubeId: post.pDetailsContent.split('?')[0], // Clean YouTube ID
        imageUrl: post.pDetailsFileUrl || '/default-image.jpg',
        category: post.category || 'Default Category', // Add category if needed
      }));
    },
    paginatedVideoData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.formatedVideoData.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.formatedVideoData.length / this.itemsPerPage) || 1;
    },
    tabMenu() {
      return {
        title: this.$t('sistemi_prokurorial.news.title'),
        all: this.$t('sistemi_prokurorial.news.all'),
        kpk: this.$t('sistemi_prokurorial.news.kpk'),
        psh: this.$t('sistemi_prokurorial.news.psh'),
        all_button: this.$t('sistemi_prokurorial.news.all_button'),
      };
    },
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.currentPage;

      if (total <= 5) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        if (current <= 3) {
          pages.push(1, 2, 3, 4, '...', total);
        } else if (current >= total - 2) {
          pages.push(1, '...', total - 3, total - 2, total - 1, total);
        } else {
          pages.push(1, '...', current - 1, current, current + 1, '...', total);
        }
      }
      return pages;
    },
  },
  created() {
    this.fetchVideoPosts(); // Call the correct method
  },
  methods: {
    async fetchVideoPosts() {
      const postsData = {
        webPage: this.webPage,
        language: this.language,
        count: this.count,
        categoryId: this.categoryId,
      };
      try {
        await this.postStore.getVideoPosts(postsData);
      } catch (error) {
        console.error('Error fetching posts:', error);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
      }
    },
  },
};
</script>



<style scoped>
.news {
    background-color: #eff2f5;
    padding-top: 40px;
}

.showall {
    background-color: #2c3f5e;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
    color: #0b0a21;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0%;
    background-color: #dde3eb;
    border-bottom: 0;
    border-radius: 6px;
}

.nav-link {
    font-size: 14px;
    color: #0b0a21;
    margin-left: 8px;
}

.nav-tabs {
    border-bottom: 0;
}

.headTitle {
    font-weight: 600;
    line-height: 30px;
    letter-spacing: -1%;
}

/* Pagination Styles */
.pagination {
    margin-top: 20px;
}

.page-link {
    color: #0b0a21;
    border: 1px solid #dde3eb;
    margin: 0 5px;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
}

.page-link:hover {
    background-color: #dde3eb;
}

.page-item.active .page-link {
    background-color: #2c3f5e;
    color: white;
    border-color: #2c3f5e;
}

.page-item.disabled .page-link {
    color: #6c757d;
    cursor: not-allowed;
    background-color: #f8f9fa;
    border-color: #dee2e6;
}
</style>